import Plyr from 'plyr';
require('../../node_modules/plyr/dist/plyr.css');

document.addEventListener('DOMContentLoaded', function () {
  const storiesEl = document.querySelector('#stories');
  if (!storiesEl) return;

  let initialized = false;

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !initialized) {
        initialized = true;
        observer.disconnect();

        initStoryPlayers();
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px -100% 0px',
    threshold: 0
  });

  observer.observe(storiesEl);

  function initStoryPlayers() {
    console.log('Odpalam player-y, bo #stories dotknął dolnej krawędzi ekranu.');


    const playerHolder = document.querySelectorAll('.js-player-holder');

    playerHolder.forEach(function (playerHolder) {
      const storyPlayers = playerHolder.querySelector('.js-story-player');
      const provider = storyPlayers.dataset.plyrProvider;
      const embedId = storyPlayers.dataset.plyrEmbedId;

      if (provider && embedId) {
        const plyr = new Plyr(storyPlayers, {
          provider: provider,
          embedId: embedId,
          autoplay: false,
          playsinline: true,
          controls: ['play', 'progress', 'volume', 'mute', 'play-large'],
          vimeo: {
            byline: false,
            portrait: false,
            title: false,
            transparent: false,
            controls: false,
            dnt: true
          }
        });

        plyr.on('ready', () => {
          playerHolder.classList.add('is-ready');
        });

        const checkIframe = setInterval(() => {
          const iframe = playerHolder.querySelector('iframe');

          console.log(iframe);
          if (iframe) {
            iframe.addEventListener('load', () => {
              playerHolder.classList.add('is-loaded');
            });
            clearInterval(checkIframe);
          }
        }, 100);
      } else {
        console.warn('Nie znaleziono danych dla Plyr:', playerHolder);
      }
    });
  }

});


